// CFG: Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
  // CFG: IIFE to encapsulate the filter display logic
  (function() {
    // CFG: Select all "Show more" buttons
    const cfgShowMoreButtons = document.querySelectorAll('.cfg-filter-show-more');
    // CFG: Select all "Show less" buttons
    const cfgShowLessButtons = document.querySelectorAll('.cfg-filter-show-less');

    // CFG: Add event listeners to "Show more" buttons
    cfgShowMoreButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        // CFG: Find the parent container for this filter group's values
        const valuesContainer = this.closest('.cfg-filter-values-container');
        if (!valuesContainer) {
          // CFG: Log an error if the container isn't found, for debugging
          console.error('CFG Error: Could not find .cfg-filter-values-container for "Show more" button.');
          return;
        }

        // CFG: Find all hidden items within this specific filter group
        const itemsToUnhide = valuesContainer.querySelectorAll('.cfg-filter-item-hidden');
        itemsToUnhide.forEach(function(item) {
          item.classList.remove('cfg-filter-item-hidden');
        });

        // CFG: Hide the "Show more" button
        this.style.display = 'none';

        // CFG: Show the corresponding "Show less" button
        const showLessButton = valuesContainer.querySelector('.cfg-filter-show-less');
        if (showLessButton) {
          showLessButton.style.display = 'inline-block'; // Or 'block' or as appropriate
        } else {
          // CFG: Log an error if the "Show less" button isn't found, for debugging
          console.error('CFG Error: Could not find .cfg-filter-show-less button within .cfg-filter-values-container.');
        }
      });
    });

    // CFG: Add event listeners to "Show less" buttons
    cfgShowLessButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        // CFG: Find the parent container for this filter group's values
        const valuesContainer = this.closest('.cfg-filter-values-container');
        if (!valuesContainer) {
          // CFG: Log an error if the container isn't found, for debugging
          console.error('CFG Error: Could not find .cfg-filter-values-container for "Show less" button.');
          return;
        }

        // CFG: Find the list of values to get the initial limit
        const valuesList = valuesContainer.querySelector('.cfg-filter-values-list');
        if (!valuesList) {
          // CFG: Log an error if the list isn't found, for debugging
          console.error('CFG Error: Could not find .cfg-filter-values-list within .cfg-filter-values-container.');
          return;
        }

        // CFG: Get the initial display limit from the data-initial-limit attribute.
        // CFG: This attribute should be set in the Liquid template on the .cfg-filter-values-list element.
        let initialLimit = 7; // CFG: Default fallback if attribute is missing or invalid
        if (valuesList.dataset.initialLimit) {
          const parsedLimit = parseInt(valuesList.dataset.initialLimit, 10);
          if (!isNaN(parsedLimit) && parsedLimit > 0) {
            initialLimit = parsedLimit;
          } else {
            // CFG: Log a warning if the parsed limit is invalid
            console.warn('CFG Warning: Invalid data-initial-limit value. Using default: ' + initialLimit);
          }
        } else {
          // CFG: Log a warning if the data attribute is not found
          console.warn('CFG Warning: data-initial-limit attribute not found on .cfg-filter-values-list. Using default: ' + initialLimit);
        }

        // CFG: Get all filter items (li elements) within this specific list
        const allItems = valuesList.querySelectorAll('li');

        allItems.forEach(function(item, index) {
          // CFG: Add the hidden class if the item's index is at or after the limit
          if (index >= initialLimit) {
            item.classList.add('cfg-filter-item-hidden');
          }
        });

        // CFG: Hide the "Show less" button
        this.style.display = 'none';

        // CFG: Show the corresponding "Show more" button
        const showMoreButton = valuesContainer.querySelector('.cfg-filter-show-more');
        if (showMoreButton) {
          showMoreButton.style.display = 'inline-block'; // Or 'block' or as appropriate
        } else {
           // CFG: Log an error if the "Show more" button isn't found, for debugging
          console.error('CFG Error: Could not find .cfg-filter-show-more button within .cfg-filter-values-container.');
        }
      });
    });

  })(); // CFG: End of IIFE
});
